export const SUCCESS_FEE_ES = {
  backCta: 'Volver al servicios',
  moreInfo: 'Más información',
  successFee: {
    title: 'Tarifa a éxito',
    footer: 'Total de la tarifa a éxito',
    successFeeFromSalary: {
      title:
        '$t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) from Salary',
      description:
        'Package $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" }) multiplied the % fee indicated in the contract $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }). <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    bonusBenefitOffer: {
      title: '{{ bonusBenefit.description }}',
      description:
        'Variable bonus calculated as the percentage $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) of the maximum value earned by the candidate on an annual basis. <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ bonusBenefit.amount }}", "currency": "{{ currency }}" })',
    },
    bonusBenefitSalary: {
      title: '{{ bonusBenefit.description }}',
      description:
        'Generally indicated variable bonus calculated as the percentage $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) of the candidate\'s annual gross salary. <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    carBenefit: {
      title: 'Company car',
      description:
        'Value of $t(common.formatting.monetary, { "value": "{{ companyCarBenefit.value }}", "currency": "{{ currency }}" }) established in the contract for the assignment of the company car measured as $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }). <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.monetary, { "value": "{{ companyCarBenefit.value }}", "currency": "{{ currency }}" })',
    },
    healthInsuranceBenefit: {
      title: 'Health insurance',
      description:
        'Share deriving from health insurance to the extent of $t(common.formatting.percentage, { "value": "{{ healthInsuranceBenefit.percentage }}" }). <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ healthInsuranceBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    accommodationBenefit: {
      title: 'Months of accommodation',
      description:
        'Share deriving from accommodation benefit to the extent of $t(common.formatting.percentage, { "value": "{{ accommodationBenefit.percentage }}" }). <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ accommodationBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
      // Questa descrizione non corrisponde esattamente alla cifra mostrata, che dipende anche dal numero di mesi dell'accommodation.
    },
    stockOptionsBenefit: {
      title: 'Stock options / equity investments',
      description:
        'Share deriving from stock options / company shareholdings to the extent of $t(common.formatting.percentage, { "value": "{{ stocksBenefit.percentage }}" }). <br/>Calculation: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ stocksBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    overallFee: {
      title: 'Overall fee',
    },
    minimumSuccessFeeAmount: {
      title: 'Minimum amount',
      description:
        'In compliance with the signed contract the value of the total fee is $t(common.formatting.monetary, { "value": "{{ minimumAmount }}", "currency": "{{ currency }}" })  (minimum value)',
    },
  },
  prePayments: {
    title: 'Anticipos ya facturados',
    footer: 'Total anticipos',
    retainerFee: {
      title: 'Retainer fee',
    },
    confidenceFee: {
      title: 'Confidence fee',
    },
  },
  total: {
    title: 'Total',
    successFee: {
      title: 'Success fee',
    },
    prePayments: {
      title: 'Paid deposit',
    },
    discount: {
      title:
        'Agreed discount ($t(common.formatting.percentage, { "value": "{{ discountPercentage }}" }))',
    },
    minimumSuccessFeeAmount: {
      title: '$t(successFee.successFee.minimumSuccessFeeAmount.title)',
      description:
        '$t(successFee.successFee.minimumSuccessFeeAmount.description)',
    },
  },
};
